module.exports = __webpack_public_path__ + "img/progress-bar-progress.0077292c.svg";